<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				<span v-if="order!=null" class="red">

					订单编号:{{order.OrderCode }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					借书数量:{{order.BookNums }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					客户信息:{{order.CustomerName +' '+ order.CustomerPhone}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					收货地址:{{order.Destination }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					订单时间:{{order.OrderDate }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
				<p>
					<input type="text" placeholder="书籍编码|或者扫描书籍二维码" @keypress="searchBook" class="search"
						v-model="searchBookCode" />
					<button type="button" class="button" :disabled="searchBookCode.length<8" @click="getBook()"
						title="点击进行查找">查找书籍</button>
				</p>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>借出书籍</th>
							<td>
								借书详情
							</td>
							<td style="width: 30rem;">
								还书详情
							</td>

						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index_i) in books">
							<td>{{index_i+1}}</td>
							<td class="red right">
								{{i.BooksName +" " +i.BooksCount+"本"}}
							</td>


							<td>
								<p v-for="y in i.boosDetail" class="returnBooks">
									借出编号:
									<span class="red"> {{ y.BooksNumCode}}
									</span><br />
									借出店铺:
									<span class="red">{{y.ShopName}}
									</span><br />
									借出位置:
									<span class="red">{{y.BorrowOutPlace}}
									</span><br />
									借出时间:
									<span class="red">{{y.BorrowDate}}
									</span><br />
									借出时间:
									<span class="red">{{getDays(y.BorrowDate)}}
									</span><br />
								</p>
							</td>
							<td>
								<p v-for="(y,indexBook) in i.boosDetail" class="returnBooks">
									还书编号:
									<input type="text" v-model="y.ReturnBooksNumCode" readonly="readonly" />
									</span><br />
									还书店铺:
									<span
										class="red">{{y.ReturnShopName==""?$store.state.shopName:y.ReturnShopName}}</span><br />
									还书位置:
									<input type="text" v-model="y.ReturnPlace" /><br />
									还书备注:
									<input type="text" v-model="y.Remarks" /><br />
									<span v-show="y.CustomerOrderBooksDetailID==0">取消还书:<button type="button"
											class="buttonSamll" @click="i.boosDetail.splice(indexBook,1)">
											取消还书</button></span>
									<span v-show="y.CustomerOrderBooksDetailID>0">
										还书时间:{{y.ReturnDate}}
									</span>
								</p>


							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>
		<p style="text-align: right; color:  red;font-size: 1.3rem;line-height:3rem; padding-right: 2rem;">
			<label>费用:<input type="text" style="width: 2rem;" v-model="payMoney" /></label>
			<label>支付:<select v-model="payType" style="vertical-align: middle;width: 3rem;">
					<option value="1">押金</option>
					<option value="2">其他</option>
				</select></label>
			<br />
			{{'合计:'+returnCount+'本'}}
			<button class="button" @click="returnBooks" :class="{'disabled':!checkReturn || returnCount==0}"
				:disabled="!checkReturn || returnCount==0">提交</button>
		</p>
	</div>

</template>

<script>
	export default {
		name: 'weChatReturnBooksDetail',
		data() {
			return {
				payType: 1,
				payMoney: 0,
				order: null,
				searchBookCode: '',
				getBook: {},
				books: [],
				borrowCount: 0,
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.user.ShopID,
				orderID: 0,
				getBook: {},
				getDays: {},
				getOrderDetail: {}
			}
		},
		created() {

			this.getOrderDetail = () => {
				this.orderID = this.$route.params.orderID;
				this.$request.request({
					url: 'weChatOrder/getReturnBooksDeatail',
					data: {
						OrderID: this.orderID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.order = res.order;
						this.books = res.books;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}

			this.getOrderDetail();
			this.getBook = function() {
				this.$request.request({
					url: 'weChatOrder/getBookByBookCode',
					data: {
						searchText: this.searchBookCode
					},
					method: 'post'
				}).then(res => {
					let isadd = false;
					if (res.result) {
						for (let i of this.books) {
							console.log(i);
							if (i.ReturnOrderID != 0 && i.ReturnOrderID == res.returnCustomerOrderID && i
								.BooksID ==
								res.BooksID) {
								for (let j of i.boosDetail) {
									if (j.BookDetailID == res.BookDetailID) {
										this.$uil.showMessage({
											text: "不得重复添加"
										});
										return;
									}
								}

								i.boosDetail.push({
									CustomerOrderBooksID: i.CustomerOrderBooksID,
									CustomerOrderBooksDetailID: 0,
									returnCustomerOrderID: res.returnCustomerOrderID,
									returnCustomerOrderBooksDetailID: res
										.returnCustomerOrderBooksDetailID,
									BookDetailID: res.BookDetailID,
									ReturnShopName: this.$store.state.shopName,
									ReturnPlace: this.$store.state.user.ShopID == res.OriginalShopID ? res
										.ReturnPlace : '',
									Remarks: '',
									ReturnBooksNumCode: res.BooksNumCode,
									BorrowDate: res.BorrowDate,
									ShopName: res.ShopName,
									BooksNumCode: res.BooksNumCode,
									BorrowOutPlace: res.BorrowOutPlace,
									BorrowoutShopID: res.BorrowoutShopID,
									BookID: i.BooksID
								});
								this.searchBookCode = "";
								isadd = !isadd;
								break;
							}
						}
						if (!isadd)
							this.$uil.showMessage({
								text: "无借出记录"
							});
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
			this.getDays = function(v) {

				let date = new Date(v.replace(/-/g, '/'));
				let now = new Date();
				return Math.ceil((now - date) / 1000 / 60 / 60 / 24) + '天';
			}
		},
		methods: {
			searchBook(e) {
				if (e.keyCode == 13) {
					this.getBook();

				}
			},
			returnBooks() {
				let retrunBooks = [];
				for (let i of this.books) {
					for (let j of i.boosDetail) {
						if (j.CustomerOrderBooksDetailID == 0)
							retrunBooks.push(j);
					}
				}


				this.$request.request({
					url: 'weChatOrder/returnBooks',
					data: {
						OrderID: this.orderID,
						ShopID: this.$store.state.user.ShopID,
						OperatorID: this.$store.state.user.UserID,
						retrunBook: JSON.stringify(retrunBooks),
						CustomerID: this.order.CustomerID,
						PayMoney: this.payMoney,
						type: this.payType
					},
					method: 'post'

				}).then(res => {
					this.$uil.showMessage({
						text: res.message
					});
					this.getOrderDetail();
					this.payMoney = 0;
				});



			}
		},
		computed: {
			returnCount() {
				let sum = 0;
				for (let i of this.books) {
					for (let j of i.boosDetail) {
						if (j.CustomerOrderBooksDetailID == 0) sum++;
						if (this.getDays(j.BorrowDate) > 30)
							this.payMoney += this.getDays(j.BorrowDate) - 30;
					}
				}
				return sum;
			},
			checkReturn() {
				//for (let i of this.books) {
				//	for (let j of i.boosDetail) {
				//	if (i.ReturnShopName != i.ShopName) {
				//		if (i.ReturnPlace == "") return false;
				//	}
				//}
				//}
				return true;
			}

		},

		watch: {
			$route(n, o) {
				if (n.path.indexOf('returnBooksDetail') == -1) return;
				let nbooksid = n.params.orderID;
				let obooksid = o.params.orderID;
				if (nbooksid != obooksid)
					this.getOrderDetail();
			}

		}

	}
</script>

<style>
</style>
